// ProtectedRoute.js - Component to protect routes with authentication
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validateToken, clearAuth } from "../utils/auth";
import Loading from "./Loading";

const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      setIsValidating(true);
      const validation = await validateToken();

      if (validation.valid) {
        setIsAuthenticated(true);
      } else {
        // Token is invalid - clear auth and redirect to login
        clearAuth();
        setIsAuthenticated(false);
        navigate("/", { replace: true });
      }
      setIsValidating(false);
    };

    checkAuth();
  }, [navigate]);

  if (isValidating) {
    return <Loading message="Verifying authentication..." />;
  }

  if (!isAuthenticated) {
    return null; // Will redirect to login
  }

  return children;
};

export default ProtectedRoute;

